
import { defineComponent } from "vue";
import TitlebarButtons from "@/components/shared/TitlebarButtons.vue"; // @ is an alias to /src
import axios from "axios";

type Event = {
  title: string;
  category: string;
  place: string;
  date: string;
  time: string;
  link?: string;
  linkText?: string;
};

export default defineComponent({
  name: "Calendar",
  components: {
    TitlebarButtons
  },
  emits: ["update-focus", "update-maximization"],
  data: () => ({
    title: "Kalender",
    days: [0],
    month: "None",
    year: "2020",
    current: {} as Event,
    checkedCategories: [] as string[],
    events: [] as Event[]
  }),
  created: function() {
    axios
      .get("./_content/calendar.json")
      .then((response) => {
        this.events = response.data;
        this.checkedCategories = this.getCategories().map((v) => v.title);
      })
      .catch((error) => console.error(error));
  },
  mounted() {
    const now = new Date();
    this.month = [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ][now.getMonth()];
    this.days = this.constructMonth(now.getMonth(), now.getFullYear()).reduce(
      (resultArray: any[], item: any, index: number) => {
        const chunkIndex = Math.floor(index / 7);

        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = []; // start a new chunk
        }

        resultArray[chunkIndex].push(item);

        return resultArray;
      },
      []
    );
  },
  methods: {
    updateFocus(focusValue: string) {
      this.$emit("update-focus", focusValue);
    },
    updateMaximization() {
      this.$emit("update-maximization", "calendar");
    },
    getCategories(): { title: string; color: string }[] {
      const colors = ["#3c3c3c", "#969696", "#5a5a5a", "#787878", "#1e1e1e"];
      return this.events
        ?.map((e) => e.category)
        ?.filter((value, index, self) => self.indexOf(value) === index)
        ?.map((v: string, i: number) => ({
          title: v,
          color: colors[i % colors.length]
        }));
    },
    getCategoryColor(category: string): string {
      return (
        this.getCategories().find((v) => v.title === category)?.color || "white"
      );
    },
    setSelectedEvents(): Event[] {
      return this.events.filter((e) =>
        this.checkedCategories.includes(e.category)
      );
    },
    getEventsOfMonth(month?: number): Event[] {
      return this.setSelectedEvents().filter(
        (e) => new Date(e.date).getMonth() === (month || new Date().getMonth())
      );
    },
    getEventsOfDay(day: {
      day: number;
      monthOffset: number;
      isCurrent: boolean;
    }): Event[] {
      return this.getEventsOfMonth(
        new Date().getMonth() + day.monthOffset
      ).filter((e) => new Date(e.date).getDate() === day.day);
    },
    getFirstDayOfMonth(zeroBasedMonthNum: number, fullYear: number) {
      const monthNames = [
        "January",
        "Febuary",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      const dateStr = `${monthNames[zeroBasedMonthNum]} 1, ${fullYear}, 00:00:00`;
      const monthStart = new Date(dateStr);
      return monthStart;
    },
    daysInMonth(zeroBasedMonthNumber: number) {
      return [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][
        zeroBasedMonthNumber
      ];
    },
    constructMonth(monthIndex: number, year: number) {
      let firstDay = this.getFirstDayOfMonth(monthIndex, year).getDay();
      if (firstDay == 0) {
        firstDay = 6;
      } else {
        firstDay--;
      }

      const daysFromLastMonth = firstDay;
      const result = [];

      const daysInLastMonth = this.daysInMonth(monthIndex - 1);
      const first = daysInLastMonth - daysFromLastMonth + 1;
      for (let i = 0; i < daysFromLastMonth; i++) {
        //result.push(first+i);
        result.push({ day: first + i, monthOffset: -1, isCurrent: false });
      }

      for (let i = 1; i <= this.daysInMonth(monthIndex); i++) {
        //result.push( i );
        result.push({
          day: i,
          monthOffset: 0,
          isCurrent: i === new Date().getDate()
        });
      }

      const daysDone = result.length;
      const daysToGo = 6 * 7 - daysDone;
      for (let i = 1; i <= daysToGo; i++)
        //result.push( i );
        result.push({ day: i, monthOffset: +1, isCurrent: false });

      return result;
    }
  }
});
